<template>
	<Col>
		<Row class="flex-align-center">
			<AppTooltip :disabled="!showToolTip" position="top" :text="accountName">
				<WorkspaceAvatar :style="{ minWidth: size + 'px' }" :size="size" :account="account" />
			</AppTooltip>
			<h3 v-if="showText" class="reg ml-2">{{ accountName }}</h3>
		</Row>
	</Col>
</template>

<script>
export default {
	name: 'AppWorkspaceAvatar',
	props: {
		showText: { type: Boolean, default: true },
		size: { type: [Number, String], default: 25 },
		showToolTip: { type: Boolean, default: true },
		account: { type: Object, default: () => ({ name: ' ' }) },
	},
	computed: {
		accountName() {
			return this.account.name;
		},
	},
};
</script>
<style scoped lang="scss"></style>
